<ng-template #loading>
    <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
</ng-template>
<p-toolbar>
    <p-toggleButton
        inputId="hideNoPayrollCode"
        [(ngModel)]="hideNoPayrollCode"
        (ngModelChange)="hideNoPayrollCodeChanged($event)"
        [onLabel]="'Show Items not Assigned a Code'"
        [offLabel]="'Hide Items not Assigned a Code'"
    ></p-toggleButton>
</p-toolbar>
<p-table stripedRows #dataTable
    [value]="filteredItems$ | async"
    tableStyleClass="table p-datatable-full"
    dataKey="id"
    editMode="row"
    [style]="{ 'min-width': '70em', width: '100%' }"
    scrollHeight="65vh"
    [scrollable]="true"
    [virtualRowHeight]="30"
    styleClass="p-datatable-center"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header>
        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- Status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Payroll Item-->
            <th>
                Payroll Item
                <p-sortIcon
                    pSortableColumn="PIListID"
                    field="PIListID"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="PIListID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                        defaultLabel="Filter"
                        maxSelectedLabels="1"
                        appendTo="body"
                        [options]="payrollItemsSelectItems"
                        [filter]="true"
                        styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                    ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Payroll Code-->
            <th>
                Payroll Code
                <p-sortIcon
                    pSortableColumn="ExportCode"
                    field="ExportCode"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="ExportCode" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                        defaultLabel="Filter"
                        maxSelectedLabels="1"
                        appendTo="body"
                        [options]="payrollCodes"
                        [filter]="true"
                        styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                    ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-item let-edit="editing" let-ri="rowIndex">
        <tr
            [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item?.id }}"
            [ngClass]="{
                'ui-editing-row': edit && editing?.id === item?.id
            }"
        >
            <!-- Edit -->
            <td class="edit-cell">
                <!-- for a new row -->
                <button
                    *ngIf="item?.id === 'add' && !editing && !edit"
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-plus"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditInit(item)"
                ></button>
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === item?.id) &&
                        item?.id !== 'add'
                    "
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text"
                    (click)="onRowEditInit(item)"
                    title="Edit"
                ></button>
                <button
                    *ngIf="edit"
                    [disabled]="!(item?.PIListID && item?.ExportCode)"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success"
                    [ngClass]="{
                        disabled: !(item?.PIListID && item?.ExportCode)
                    }"
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Payroll Item-->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item?.IsReadOnly" pTemplate="input">
                        <div
                            *ngIf="
                                availablePayrollItemsSubject.asObservable()
                                    | async as ai;
                                else loading
                            "
                        >
                            <p-select
                                [ngClass]="{
                                    'ng-invalid': !item?.PIListID
                                }"
                                [panelStyle]="{ width: '10rem' }"
                                [ngModelOptions]="{ standalone: true }"
                                [autoDisplayFirst]="false"
                                appendTo="body"
                                [options]="ai"
                                [(ngModel)]="item.PIListID"
                            ></p-select>
                        </div>
                    </ng-template>
                    <ng-template *ngIf="item?.IsReadOnly" pTemplate="input">
                        {{
                            (items | itemlookup: 'PIListID':item?.PIListID)
                                ?.PayrollItem
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                            (items | itemlookup: 'PIListID':item?.PIListID)
                                ?.PayrollItem
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Payroll Code-->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item?.IsReadOnly" pTemplate="input">
                        <p-select
                            [ngClass]="{
                                'ng-invalid': !item.Paycodeid
                            }"
                            [panelStyle]="{ width: '10rem' }"
                            [ngModelOptions]="{ standalone: true }"
                            [autoDisplayFirst]="false"
                            appendTo="body"
                            [options]="payrollCodes"
                            [(ngModel)]="item.ExportCode"
                            [style]="{'width': '100%'}"
                        ></p-select>
                    </ng-template>
                    <ng-template *ngIf="item?.IsReadOnly" pTemplate="input">
                        {{
                            (
                                payrollCodes
                                | itemlookup: 'value':item?.ExportCode
                            )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                            (
                                payrollCodes
                                | itemlookup: 'value':item?.ExportCode
                            )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
        </tr>
    </ng-template>
</p-table>
